module.exports = __webpack_public_path__ + "img/stephen-masiangoako.cf4cbf47.png";